export const GET_COMMON_PARTY_DROPDWON_OPTION_ACTION = "GET_COMMON_PARTY_DROPDWON_OPTION_ACTION"
export const GET_COMMON_PARTY_DROPDWON_OPTION_ACTION_SUCCESS = 'GET_COMMON_PARTY_DROPDWON_OPTION_ACTION_SUCCESS'

export const COMMON_PARTY_DROP_SELECT_ACTION = "COMMON_PARTY_DROP_SELECT_ACTION"
export const COMMON_PARTY_DROP_SELECT_ACTION_SUCCESS = 'COMMON_PARTY_DROP_SELECT_ACTION_SUCCESS'

export const CHANGE_COMMON_PARTY_DROPDWON_DETAILS_ACTION = "CHANGE_COMMON_PARTY_DROPDWON_DETAILS_ACTION"

export const SIDE_BAR_PAGE_FILTERS_INFO_ACTION = "SIDE_BAR_PAGE_FILTERS_INFO_ACTION"
export const SIDE_BAR_PAGE_FILTERS_INFO_ACTION_SUCCESS = "SIDE_BAR_PAGE_FILTERS_INFO_ACTION_SUCCESS"